import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { VehicleKVPTable } from '@/components/Vehilces/VehicleKVPTable';
import type { CmsVehicle } from '@/services/cms/models/CmsVehicle';
export type VehicleSpecsTableProps = {
  vehicle: CmsVehicle;
};
const specConfig: {
  key: keyof CmsVehicle;
  label: string;
  format?: (vehicle: CmsVehicle) => string;
}[] = [{
  key: 'year',
  label: 'Year'
}, {
  key: 'berths',
  label: 'Berths',
  format: v => `${v.berths} berth${v.berths > 1 ? 's' : ''}`
}, {
  key: 'odometer',
  label: 'Odometer',
  format: v => `${v.odometer} km`
}, {
  key: 'engineCapacity',
  label: 'Engine Capacity',
  format: v => `${v.engineCapacity}L`
}, {
  key: 'length',
  label: 'Length',
  format: v => `${v.length}m`
}, {
  key: 'fuelCapacity',
  label: 'Fuel Capacity',
  format: v => `${v.fuelCapacity}L`
}, {
  key: 'width',
  label: 'Width',
  format: v => `${v.width}m`
}, {
  key: 'height',
  label: 'Height',
  format: v => `${v.height}m`
}, {
  key: 'internalHeight',
  label: 'Internal Height',
  format: v => `${v.internalHeight}m`
}];
export function VehicleSpecsTable(t0) {
  const $ = _c(4);
  const {
    vehicle
  } = t0;
  let records;
  if ($[0] !== vehicle) {
    records = specConfig.map(t1 => {
      const {
        key,
        label,
        format
      } = t1;
      const value = vehicle[key];
      if (value === undefined || value === null || value === "") {
        return null;
      }
      return {
        label,
        value: format ? format(vehicle) : value
      };
    }).filter(Boolean) as {
      label: string;
      value: string | number;
    }[];
    if (vehicle.specifications) {
      records.push(...Object.entries(vehicle.specifications).map(_temp));
    }
    $[0] = vehicle;
    $[1] = records;
  } else {
    records = $[1];
  }
  let t1;
  if ($[2] !== records) {
    t1 = <VehicleKVPTable records={records} />;
    $[2] = records;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(t0) {
  const [label_0, value_0] = t0;
  return {
    label: label_0,
    value: value_0
  };
}